import { Injectable } from "@angular/core";
import { BaseService } from "../../core";
import { environment } from "environments/environment";
import { HttpClient } from "@angular/common/http";
import { TopicoResponse } from "app/shared/models/ei-models";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class TopicoService extends BaseService {
    private controllerEndpoint = environment.urlEdducaImobApi.concat('api/Topico/');

    constructor(private httpClient: HttpClient) {
        super();
    }

    listarTopicos(): Observable<Array<TopicoResponse>> {
        return this.httpClient.get<Array<TopicoResponse>>
            (this.controllerEndpoint.concat('ListarTopicos'), { headers: this.getHeader(true) });
    }
}